import { render, staticRenderFns } from "./AddressInformationModal.vue?vue&type=template&id=384dd323&scoped=true"
import script from "./AddressInformationModal.vue?vue&type=script&lang=js"
export * from "./AddressInformationModal.vue?vue&type=script&lang=js"
import style0 from "./AddressInformationModal.vue?vue&type=style&index=0&id=384dd323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384dd323",
  null
  
)

export default component.exports